"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cognitoInfoApp = exports.MIN_PASSWORD_LENGTH = void 0;
const deployment_environments_1 = require("./deployment-environments");
const deployment_environment_1 = require("../model/deployment-environment");
exports.MIN_PASSWORD_LENGTH = 8;
exports.cognitoInfoApp = (0, deployment_environment_1.perDeploymentEnv)({
    [deployment_environments_1.DeploymentEnvironment.DEV]: {
        userPoolId: "eu-central-1_97ZQpbcXo",
        identityPoolId: "eu-central-1:fa11b5cf-95e8-4db1-b6ab-33e5a1a87d8d",
        userPoolClientId: "7slcon6khavgfcolohamtikomu",
    },
    [deployment_environments_1.DeploymentEnvironment.PROD]: {
        userPoolId: "eu-central-1_6RM2Gw9T2",
        identityPoolId: "eu-central-1:9ef8739a-c795-43a4-852d-b9b0749f0d48",
        userPoolClientId: "2oqa2r71tmplov5q4ju9f8ju4u",
    },
});
